/*
 * streetsReducer
 * Description
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 * @version 1.0.0
 * @author Lucio Chiummo
 * @since 27-May-2025
 */

import { produce } from 'immer'
import { actionTypes } from '../actions/address'

const ACTION_HANDLERS = {
  // @generator reducer:type:action
  [actionTypes.GET_COUNTRIES]: produce((draft) => {
    draft.loading = true
  }),
  [actionTypes.GET_PROVINCES]: produce((draft) => {
    draft.loading = true
  }),
  [actionTypes.GET_MUNICIPALITIES]: produce((draft) => {
    draft.loading = true
  }),
  [actionTypes.GET_STREETS]: produce((draft) => {
    draft.loading = true
  }),
  [actionTypes.GET_COUNTRIES_SUCCESS]: produce((draft, action) => {
    draft.countries = action.response.data.countries
    draft.loading = false
  }),
  [actionTypes.GET_PROVINCES_SUCCESS]: produce((draft, action) => {
    draft.provinces = action.response.data.provinces
    draft.loading = false
  }),
  [actionTypes.GET_MUNICIPALITIES_SUCCESS]: produce((draft, action) => {
    if (action.response.isSecondary) {
      draft.municipalitiesSecondary = action.response.data.municipalities
    } else {
      draft.municipalities = action.response.data.municipalities
    }
  }),
  [actionTypes.GET_MUNICIPALITIES_FAILURE]: produce((draft, action) => {}),
  [actionTypes.GET_STREETS_SUCCESS]: produce((draft, action) => {
    if (action.response.isSecondary) {
      draft.streetsSecondary = action.response.data.streets
    } else {
      draft.streets = action.response.data.streets
    }
  }),
  [actionTypes.GET_STREETS_FAILURE]: produce((draft, action) => {}),
  [actionTypes.GET_CHECK_FOREIGN_MUNICIPALITIES_SUCCESS]: produce((draft, action) => {
    draft.errorForeignMunicipalities = action.response.data.municipalities.length > 0
  }),
  [actionTypes.GET_CHECK_FOREIGN_MUNICIPALITIES_FAILURE]: produce((draft, action) => {}),
  [actionTypes.RESET_CHECK_FOREIGN_MUNICIPALITIES_ERROR]: produce((draft, action) => {
    draft.errorForeignMunicipalities = false
  })
}

// The initial state
const initialState = {
  countries: [],
  provinces: [],
  municipalities: [],
  streets: [],
  municipalitiesSecondary: [], // copy of municipalities. It is useful for pages where there are two select with municipallities options
  streetsSecondary: [], // copy of streets. It is useful for pages where there are two select with streets options
  loading: false,
  error: null,
  errorForeignMunicipalities: false
}

const address = (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default address
